import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=0891f1a7&scoped=true"
import script from "./WidgetForm.vue?vue&type=script&lang=js"
export * from "./WidgetForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetForm.vue?vue&type=style&index=0&id=0891f1a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891f1a7",
  null
  
)

export default component.exports